import MyTable from 'components/UIElements/MyTable';
import { useParams, useLocation } from 'react-router-dom';
import EndPoints from 'shared/endPoints/EndPoints.json';
import { AuthContext } from 'shared/context/auth-context';
import React, { useContext } from 'react';
import getSharedTripColumns from './sharedTripColumns';

export default function SuspendedTrips() {
  const { id } = useParams();
  const endPoint = `${EndPoints.CONTRACT.GETINVALIDTRIPS}/?contractId=${id}`;
  const location = useLocation();
  const exportFilename = ` Anytime_BTM_SuspendedTrip_History_Contract_${location.state.policyNumber}`;
  const { roleUser } = useContext(AuthContext);

  const columns = getSharedTripColumns(['GT']).filter(
    item => item.showOnRoles.indexOf(roleUser) !== -1
  );

  return (
    <MyTable
      columns={columns}
      endPoint={endPoint}
      exportFilename={exportFilename}
      ContractTab
      expandable
    />
  );
}
